import get from 'get-object-path';

export const sessionEquipment = {
    namespaced: true,

    state: {
        categories: [],
        selectedCategory: null,
        crew: null,
        previousStep: 1,
        step: 1,
        setCrewEquipment: null,
        readOnly: false
    },

    getters: {
        categories(state) {
            return state.categories;
        },

        selectedCategory(state) {
            return state.categories.find(category => category.id === state.selectedCategory);
        },

        crewEquipment(state) {
            return state.setCrewEquipment;
        },

        crew(state) {
            return state.crew;
        },

        crewInventory(state) {
            return get(state, 'crew.inventory.data') || [];
        },

        step(state) {
            return state.step;
        },

        previousStep(state) {
            return state.previousStep;
        },

        readOnly(state) {
            return state.readOnly;
        }
    },

    mutations: {
        setCategories(state, categories) {
            state.categories = categories;
        },

        setSelectedCategory(state, selectedCategory) {
            state.selectedCategory = selectedCategory;
        },

        setCrewEquipment(state, equipment) {
            state.setCrewEquipment = equipment;
        },

        setCrew(state, crew) {
            state.crew = crew;
        },

        setStep(state, step) {
            state.step = step;
        },

        setPreviousStep(state, previousStep) {
            state.previousStep = previousStep;
        },

        setReadOnly(state, readOnly) {
            state.readOnly = readOnly;
        }
    }
};

export default sessionEquipment;
